/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#000000',
    height: 64,
    iconColor: '#ffffff',
    width: 64
  }
}
export default theme
